/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "createFlowFromTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "createFlowFromWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "createFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "createFlowWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96",
            },
        ],
        name: "decreaseFlowRateAllowanceTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96",
            },
        ],
        name: "decreaseFlowRateAllowanceWithPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissionsToRemove",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "decreaseFlowRateAllowanceWithPermissionsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "int96",
                name: "subtractedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "decreaseFlowRateAllowanceWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "deleteFlowFromTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "deleteFlowFromWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "deleteFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "deleteFlowWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "getBufferAmountByFlowRateTest",
        outputs: [
            {
                internalType: "uint256",
                name: "bufferAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "getFlowInfoTest",
        outputs: [
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
        ],
        name: "getFlowPermissionsTest",
        outputs: [
            {
                internalType: "bool",
                name: "allowCreate",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "allowUpdate",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "allowDelete",
                type: "bool",
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "getFlowRateTest",
        outputs: [
            {
                internalType: "int96",
                name: "rate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getNetFlowInfoTest",
        outputs: [
            {
                internalType: "uint256",
                name: "lastUpdated",
                type: "uint256",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "uint256",
                name: "deposit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "owedDeposit",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getNetFlowRateTest",
        outputs: [
            {
                internalType: "int96",
                name: "netFlowRate",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96",
            },
        ],
        name: "increaseFlowRateAllowanceTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96",
            },
        ],
        name: "increaseFlowRateAllowanceWithPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "uint8",
                name: "permissionsToAdd",
                type: "uint8",
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "increaseFlowRateAllowanceWithPermissionsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "int96",
                name: "addedFlowRateAllowance",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "increaseFlowRateAllowanceWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "revokeFlowPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "allowCreate",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "allowUpdate",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "allowDelete",
                type: "bool",
            },
            {
                internalType: "int96",
                name: "flowRateAllowance",
                type: "int96",
            },
        ],
        name: "setFlowPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "flowOperator",
                type: "address",
            },
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "setMaxFlowPermissionsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "updateFlowFromTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "updateFlowFromWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "updateFlowTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "updateFlowWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class SuperTokenLibraryCFAMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SuperTokenLibraryCFAMock__factory.bytecode = _bytecode;
SuperTokenLibraryCFAMock__factory.abi = _abi;
//# sourceMappingURL=SuperTokenLibraryCFAMock__factory.js.map